import React from "react"
export default function Section({ children }) {
  return (
    <div className="w-11/12 mx-auto">
      <div className="container px-2 lg:px-8 mx-auto">{children}</div>
    </div>
  )
}
